// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + "b536a0f1" + "." + "6fcc620c5a57d31e" + ".js";
};